import {Upload} from 'antd'

import './ImageUpload.scss'
import {useUploadFile} from 'common/api'
import {Box, Loader, ImageIcon} from 'common/components'
import {FileInterface} from 'common/types'

export default function ImageUpload({value, onChange}: any) {
  const {mutate: uploadFile, isLoading} = useUploadFile({
    setFile: (image: FileInterface) => onChange(image),
  })

  const handleDownload = ({file}: any) => uploadFile(file)

  return (
    <div className="ImageUpload">
      <div className="ImageUpload-Wrapper">
        <Upload
          accept="image/*"
          name="image"
          listType="picture-card"
          showUploadList={false}
          disabled={isLoading}
          customRequest={handleDownload}
        >
          <Loader show={isLoading} type="block" />
          {value ? (
            <img
              className="ImageUpload-Image"
              src={value.url}
              alt="Downloaded asset"
            />
          ) : (
            <Box color="grey">
              <ImageIcon />
              <p>Image</p>
            </Box>
          )}
        </Upload>
      </div>
    </div>
  )
}
